/**
 * Checks whether a route query includes a param, even when its value is empty (e.g. `?aid`)
 *
 * @param {object} opts
 * @param {object} [opts.query={}] - route query, e.g. `this.$route.query`
 * @param {string} [opts.param=''] - query param name to look for, e.g. `aid`
 * @returns {boolean}
 */
const hasQueryParam = (opts = {}) => {
  const query = opts.query || {};

  if (!opts.param) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(query, opts.param);
};

export default hasQueryParam;
